import styled from 'styled-components'
import { Grid } from '@material-ui/core'

export const Wrapper = styled(Grid)`
  margin-top: 0.8rem;
`

export const GridSimpleCard = styled(Grid)``
